import Layout from "components/Layout";
import { EmtekPageProps } from "pages/[[...slug]]";

import { MultiLayoutCmsData, MultiLayoutSubPage } from "./MultiLayoutSubPage";
import { ToolboxStreamfield } from "./Toolbox";

export type PageProps = EmtekPageProps<MultiLayoutCmsData>;

const SupportSubPage: React.FC<PageProps> = (props) => {
    return (
        <Layout
            metadata={props.wagtail}
            menus={props.menus}
            //  promo={props.promo}
        >
            <MultiLayoutSubPage
                body={props.wagtail.body}
                split_layout_nav={props.wagtail.split_layout_nav}
            >
                <ToolboxStreamfield
                    blocks={props.wagtail.split_layout_body}
                    firstBlock={props.wagtail.body.length === 0}
                />
            </MultiLayoutSubPage>
        </Layout>
    );
};

export default SupportSubPage;
